var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",attrs:{"id":"banner"}},[_c('headerWrap'),_c('three-canvas'),_c('div',{staticClass:"__container banner-body"},[_c('banner-title'),_c('banner-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }